// ─── Paiement (Stripe) : appels SERVEUR (Core) ────────────────────
// Le Core ne parle jamais directement à Stripe : clé secrète et signature du
// webhook restent en Secret Manager, jamais côté client. Ici, seulement les
// deux callables que l'utilisateur peut déclencher lui-même.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// `scheme` : cf. AppContext (`useApp().scheme`) — l'app appelante, pour que
// Stripe sache où ramener l'utilisateur après le paiement.
export const creerSessionPaiement = (plan, scheme) =>
  httpsCallable(functions, 'creerSessionPaiement')({ plan, scheme }).then(r => r.data);

export const annulerAbonnement = () =>
  httpsCallable(functions, 'annulerAbonnement')({}).then(r => r.data);
